// SDK Modes
export var LOCALHOST_MODE = 'localhost';
export var STANDALONE_MODE = 'standalone';
export var PRODUCER_MODE = 'producer';
export var CONSUMER_MODE = 'consumer';
// Storage types
export var STORAGE_MEMORY = 'MEMORY';
export var STORAGE_REDIS = 'REDIS';
export var STORAGE_LOCALSTORAGE = 'LOCALSTORAGE';
// Special treatments
export var CONTROL = 'control';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/constants/index.js
// module id = 9f0l
// module chunks = 88